import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import delayEmptyState from '../../assets/images/grey-delay-icon.svg';
import AnnouncementWalkthroughSettings from '../../constants/AnnouncementWalkthroughSettings';
import ModalBannerConstants from '../../constants/ModalBannerConstants';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';
import dataModel from '../../models/DataModel';
import DataSource from '../../dao/DataSource/DataSource';
import DelayCard from './DelayCard';

import './DelaysContainer.scss';

export class DelaysContainer extends Component {
  
  constructor(props) {
    super(props);
    const routerState = props.history.getState();
    DelaysContainer.propTypes = {
      project: PropTypes.object.isRequired,
    };

    let project = { ...props.project };
    if (routerState && routerState.newDelay && (!project.delays || !project.delays.find(delay => { return delay.id == routerState.newDelay.id; }))) {
      if (!project.delays) {
        project.delays = [];
      }
      project.delays.unshift(routerState.newDelay);
      project.delays.sort((d1, d2) => {
        return d1.id < d2.id ? 1 : -1;
      });
    }

    this.state = {
      project,
      newDelay: routerState ? routerState.newDelay : null,
    };

    if (routerState && routerState.newDelay) {
      props.history.clearState();
    }

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({ currentRole, isMobile: !!window.cordova });
    this.createDelay = this.createDelay.bind(this);
    this.viewDelay = this.viewDelay.bind(this);
    this.createDelaysList = this.createDelaysList.bind(this);
  }

  handleProjectRetrieved(project, action, acData, fetchedData) {
    if (project.has_alerts && project.has_unread_alerts) {
      dataModel.AlertsDAO.markAllReadByProjectId(project.id);
    }
    project.delays.sort((d1, d2) => {
      return d1.id < d2.id ? 1 : -1;
    });
    this.setState({ project });
  }

  componentDidMount() {
    this.projectDataSource = new DataSource('Project', this.props.project.id, {
      project: {
        additionalFields: ['has_alerts', 'has_unread_alerts'],
        delays: {
          attachments: { additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'] },
        },
      },
    }, this.handleProjectRetrieved);
    if (!!window.cordova && this.props.currentUser && (!this.props.currentUser.settings || !this.props.currentUser.settings.user_has__viewed_mobile_delays_announcement_delays)) {
      const internalElement = <div className="announcement-highlight">
      <div className='mock-delay-button'>REPORT A DELAY</div>
    </div>;

      let settings = _.cloneDeep(AnnouncementWalkthroughSettings.DelaysPageAnnouncement);
      settings.highlightSettings.internalElement = internalElement;

      dataModel.showCircleGlobalModal(ModalBannerConstants.DELAYS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT, {
        side: 'left-side', userSetting: 'user_has__viewed_mobile_delays_announcement_delays', announcementSettings: settings,
      });
    }  
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
  }

  createDelay() {
    const { history } = this.props;
    const { project } = this.state;
    this.analyticsLogger.logDelayEvent('ReportADelayClicked');
    history.push({
      pathname: '/mobile/projects/'+project.id+'/add-delay/type',
      state: { project },
    });
  }

  viewDelay(delay, iconSrc) {
    const { history, displayReadOnly } = this.props;
    const { project } = this.state;
    
    if (displayReadOnly) {
      displayReadOnly(delay, iconSrc);
    }
    else {
      history.push({
        pathname: '/mobile/projects/'+project.id+'/delays/'+delay.id,
        state: { project, delay, iconSrc },
      });
    }
  }

  createDelaysList() {
    const { project, newDelay } = this.state;
    if (project) {
      const delaysList = project.delays.map(delay => {
        if (delay.id) {
          return <DelayCard key={delay.id} delay={delay} viewDelay={this.viewDelay}
            animate={newDelay && newDelay.id == delay.id}/>;
        }
        return false;
      });

      return <section className="delay-content">
        <div className="delay-list">
        <div className="delay-list-scroller">
          {delaysList}
          </div>
          </div>
      </section>;
    }
  }

  render() {
    const { project, newDelay } = this.state;
    let content = null;
    
    if ((!project || !project.delays || !project.delays.length) && !newDelay) {
      content = < section className='delay-content empty-state' >
        <img src={delayEmptyState} alt="empty state" className='delay-empty-state' />
        <h1>Woohoo!</h1>
        <h1>This project has no delays.</h1>
      </section>;
    }
    else {
      content = this.createDelaysList();
    }

    return (
      <article className='delays-container'>
        {content}
        <div className='report-delay-container'>
          <button onClick={this.createDelay} id='report-delay-btn'>REPORT A DELAY</button>
        </div>
      </article>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users.currentUser,
  };
};
export default withRouter(connect(mapStateToProps)(DelaysContainer));



// WEBPACK FOOTER //
// ./src/components/DelaysContainer/index.js